import axios from "@/lib/axios";

import { Corporation } from "@/interfaces/corporation";
import { useMutation, useQuery } from "@tanstack/vue-query";

export const getCorporation = async (id: number) => {
  const { data } = await axios.get<Corporation>(`/api/corporations/${id}`);

  return data;
};

const createCorporation = async (name: string): Promise<Corporation> => {
  const { data } = await axios.post(`/api/corporations`, { name });
  return data;
};

const useCorporation = (id?: number) => {
  const createMutation = useMutation(createCorporation);

  const { data, isLoading, isError } = useQuery(
    ["corporation", id],
    () => getCorporation(id!),
    {
      enabled: !!id,
    },
  );

  return {
    data,
    isError,
    isLoading,
    createMutation,
  };
};

export default useCorporation;
